import { useState, useReducer, useRef, useEffect } from "react"
import { select } from 'd3-selection'
import { axisBottom, axisLeft } from 'd3-axis'
import { scaleLinear } from 'd3-scale'
import { zoom } from 'd3-zoom'
import Select from "../widgets/Select.jsx";
import { downloadFile, decoratedlist, horizontalList, HeaderWithModal } from "../utils.jsx"


const TranscriptDrawer = ({trxp, protDetails }) => {
   
    const margin = {top: 50, right: 30, bottom: 20, left: 40}
    const width = 1000 - margin.left - margin.right
    const height = 300 - margin.top - margin.bottom
    const svgRef = useRef();
    function reverse(segments, maxVal) {
        return (
            segments.map(pair => pair.map(num => Math.abs(maxVal - num))).map(inner => inner.slice().sort((a, b) => a - b)).sort((a, b) => a[0] - b[0])
    )
    }
    useEffect(() => {
        if (svgRef.current && protDetails.length > 0 ) {


            const segments = JSON.parse(trxp[0].transcript_segments);
            const minValue = Math.min(...segments.flat());
            var exons = segments.map(pair => pair.map(num => num - minValue));
            console.log(exons)
            const maxVal = Math.max(...exons.flat());
            
            if (protDetails[0].strand  === -1) {
                var exons = reverse(exons, maxVal);
            }
            
            const exonGaps = exons.slice(0, -1).map((exon, i) => [exon[1], exons[i + 1][0]]);
            const prot_segments = JSON.parse(protDetails[0].segments);
            var prot_segments_norm = prot_segments.map(pair => pair.map(num => num - minValue));
            if (protDetails[0].strand === -1) {
                var prot_segments_norm = reverse(prot_segments_norm, maxVal);
            }

            const xScale = scaleLinear().domain(
                [0, Math.max(...exons.flat())]
            ).range([margin.left, width]);
            const yScale = scaleLinear().domain([0, 1]).range([height, margin.top]);

            function drawExon(exon, y) {
                return (`M${xScale(exon[0])},${y}L${xScale(exon[1])},${y}`);
            }
            function drawExonGaps(exonGap, y) {
                const gap_half = exonGap[0] + (Math.abs(exonGap[1] - exonGap[0])/2)
                return (`M${xScale(exonGap[0])},${y}L${xScale(gap_half)},${y-5}M${xScale(gap_half)},${y-5}L${xScale(exonGap[1])},${y}`);
            }
            const svg = select(svgRef.current)
            svg
                .selectAll(".exons")
                .data(exons)
                .join("path")
                .attr("d", (value, idx) => drawExon(value, 10))
                .attr("fill", "none")
                .attr("stroke", "black")
                .attr("stroke-width", 4)
            svg
                .selectAll(".exonGaps")
                .data(exonGaps)
                .join("path")
                .attr("d", (value, idx) => drawExonGaps(value, 10))
                .attr("fill", "none")
                .attr("stroke", "black")
                .attr("stroke-width", 0.5)
                .attr("stroke-dash-array", "1,5")
            
            var segColor = "#2F3CCD"
            if (protDetails[0].type == "cryptic") {
                var segColor = "#CF2646"
            }
            if (protDetails[0].type == "isoform") {
                var segColor = "#E4B131"
            }

            trxp.sort((t2, t1) => JSON.parse(t2.prot_segments)[0][0] - JSON.parse(t1.prot_segments)[0][0])
            if (protDetails[0].strand === -1) {
                trxp.sort((t1, t2) => JSON.parse(t2.prot_segments)[0][1] - JSON.parse(t1.prot_segments)[0][1])

            }
            for (let i = 0; i < trxp.length; i++) {
                var segs = JSON.parse(trxp[i].prot_segments).map(pair => pair.map(num => num - minValue));
                if (protDetails[0].strand === -1) {
                    var segs = reverse(segs, maxVal);
                }
                var segColor = "#7C83D2"
                if (trxp[i].prot_type == "cryptic") {
                    var segColor = "#C77182"
                }
                if (trxp[i].prot_type == "isoform") {
                    var segColor = "#E4C780"
                }
                svg
                    .selectAll("seg")
                    .data(segs)
                    .join("path")
                    .attr("d", (value, idx) => drawExon(value, 20 + (30*i)))
                    .attr("fill", "none")
                    .attr("stroke", segColor)
                    .attr("stroke-width", 6)
                svg
                    .selectAll("label")
                    .data([trxp[i]])
                    .join(
                        enter => enter.append("a")
                        .attr("xlink:href", value => `https://test.openprot.org/proteins/HS/${value.protein_seq_id}`)
                        .append("text")
                        .attr("x", xScale(segs[0][0]))
                        .attr("y", 35 + (30*i))
                        .style("font-size", 12)
                        .text(d => d.prot_acc)
                        .attr("fill", "blue"),
                        update => update.select("text").text(d => d.prot_acc),
                        exit => exit.remove()

                    )
                    
            }    

        }
        
    }, [`${svgRef.current ? 'non':'oui'}`, protDetails.length]);

    return (
        <>Transcript: {trxp[0].trans_accession} | strand: 
            <svg ref={svgRef} width={width} height={height + margin.top + margin.bottom}></svg>
        </>
    )
}

export default TranscriptDrawer
